<template>
  <div class="make">
    <div class="list">
      <div class="item" v-for="i in 5000">
        <span>{{userInfo.account}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';
  export default {
    name: "watermark",
    computed: {
      ...mapGetters(["userInfo"])
    },
    props: {
      info: {
        type: String,
        default: '凸凸虾助手'
      }
    },
    data() {
      return {

      };
    }
  }
</script>

<style lang="less" scoped>
  .make {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 0);
    pointer-events: none;
    overflow: hidden;

    .list {
      width: 250%;
      height: 400%;
      position: absolute;
      top: -50%;
      left: -25%;
      margin-left: -50%;
      margin-top: -50%;
      transform: translate(-50%, -50%);
      transform: rotate(-45deg);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      pointer-events: none;

      .item {
        font-size: 14px;
        color: rgba(220, 220, 220, 0.5);
        font-weight: bold;
        padding: 20px;
        pointer-events: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/component/ywaterMark.vue